import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FormService {
  baseUrl = environment.baseUrl;
  constructor(private http: HttpClient) { }

  becomeTeacher(body: any) {
    let headers = new HttpHeaders();
    headers = headers.set('content-type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + environment.bearerToken);
    return this.http.post(`${this.baseUrl}v1/user/become-teacher/`, body, { headers });
  }

  serviceDoor(body: any) {
    let headers = new HttpHeaders();
    headers = headers.set('content-type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + environment.bearerToken);
    return this.http.post(`${this.baseUrl}v1/user/home-service/`, body, { headers });
  }

  legendService(body: any) {
    let headers = new HttpHeaders();
    headers = headers.set('content-type', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + environment.bearerToken);
    return this.http.post(`${this.baseUrl}v1/user/legend-service/`, body, { headers });
  }

  contactUs(body: any) {
    let headers = new HttpHeaders();
    headers = headers.set('content-type', 'application/json');
    return this.http.post(`${this.baseUrl}v1/user/p/contact-us/`, body, { headers });
  }

  bookSession(body: any) {
    let headers = new HttpHeaders();
    headers = headers.set('content-type', 'application/json');
    return this.http.post(`${this.baseUrl}v1/user/p/book-session/`, body, { headers });
  }

  subscribe(body: any) {
    let headers = new HttpHeaders();
    headers = headers.set('content-type', 'application/json');
    return this.http.post(`${this.baseUrl}v1/user/p/subscribe/`, body, { headers });
  }

}
